<template>
  <b-card-code title="">
    <div class="row mb-2">
      <div class="col-lg-6">
        <h4>Emelő gépek listája</h4>
      </div>
      <div class="col-lg-6 text-right">
        <button
          class="btn btn-primary"
          @click="$router.push('/lifting-machines/create')"
        >
          Új emelő gép
        </button>
      </div>
      <div class="col-lg-12 mt-2 text-right">
        <b-badge
          variant="primary"
          class="mr-1"
        >
          Összes emelő gép: {{ rows.length }}
        </b-badge>
      </div>
    </div>
    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Name -->
        <div
          v-if="props.column.field === 'name'"
          class="text-nowrap"
        >
          <span
            class="text-nowrap"
            @click="selectedData = props.row;$bvModal.show('lifting_machine_data');getLiftingMachineDetails(props.row.id)"
          >
            {{ props.row.name }}
          </span>
        </div>

        <!-- Column: Service -->
        <span v-else-if="props.column.field === 'service'">
          <div class="text-nowrap">
            <b-badge
              :variant="getNextServiceVariant(props.row)"
              style="color: white !important;"
            >
              {{ formatNextService(props.row) }}
            </b-badge>
          </div>
        </span>

        <span v-else-if="props.column.field === 'current_hours'">
          <div class="text-nowrap">
            <b-badge
              style="color: white !important;"
            >
              {{ formatCurrentHours(props.row) }}
            </b-badge>
          </div>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item @click="$router.push(`/lifting-machines/edit/${props.row.id}`)">
                <feather-icon
                  icon="Edit2Icon"
                  size="16"
                  class="mr-50"
                />
                <span>Szerkesztés</span>
              </b-dropdown-item>
              <b-dropdown-item @click="deleteThisLiftingMachine(props.row.id)">
                <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="mr-50"
                />
                <span>Törlés</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">Megjelenítés</span>
            <b-form-select
              v-model="pageLength"
              size="sm"
              :options="['3','5','10', '25', '50']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap">-ig a {{ props.total }} elemet</span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>

    <!-- Lifting Machine Details Modal -->
    <b-modal
      id="lifting_machine_data"
      title="Emelő gép adatai"
      size="lg"
      hide-footer
    >
      <b-row class="my-1 pl-1 pr-1">
        <b-col
          lg="12"
          class="mt-1"
        >
          <b>Emelő gép adatok</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Megnevezés: <b>{{ selectedData.name }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Gyártmány: <b>{{ selectedData.brand }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Típus: <b>{{ selectedData.type }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Rendszám: <b>{{ selectedData.registration_number || '-' }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Forgalomba helyezés ideje: <b>{{ selectedData.entry_into_service || '-' }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Gyártási év: <b>{{ selectedData.year_of_manufacture }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Műszaki vizsga lejárata: <b>{{ selectedData.technical_validity || '-' }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Gyártási szám: <b>{{ selectedData.manufacturing_number }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Aktuális üzemóra: <b>{{ selectedData.current_hours }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Szervíz intervallum: <b>{{ selectedData.service_interval }}</b>
        </b-col>
        <b-col
          lg="6"
          class="mt-1"
        >
          Következő szervíz: <b>{{ getNextServiceText(selectedData) }}</b>
        </b-col>
        <b-col
          lg="12"
          class="mt-3"
        >
          <hr>
          <b>Szervíz előzmények</b>
        </b-col>
        <b-col v-if="liftingMachineServices.length === 0">
          <p class="text-muted">
            Még nincs rögzített szervíz.
          </p>
        </b-col>
        <b-col v-else>
          <table class="table table-responsive">
            <tr>
              <th><b>Szervíz neve</b></th>
              <th><b>Számlaszám</b></th>
              <th><b>Elvégzés dátuma</b></th>
              <th><b>Üzemóra szervízkor</b></th>
              <th><b>Szervíz intervallum</b></th>
              <th><b>Következő szervíz</b></th>
              <th><b>Elvégzett szolgáltatások</b></th>
            </tr>
            <tr
              v-for="service_data in liftingMachineServices"
              :key="service_data.id"
            >
              <td>{{ service_data.service_name }}</td>
              <td>{{ service_data.billing_number }}</td>
              <td>{{ service_data.date_of_completion }}</td>
              <td>{{ service_data.hours_at_the_time_of_service }}</td>
              <td>{{ service_data.service_interval || '-' }}</td>
              <td>{{ formatServiceHistoryNextDue(service_data) }}</td>
              <td>
                <template v-if="Array.isArray(service_data.name_of_service)">
                  <b-badge
                    v-for="service_name in service_data.name_of_service"
                    :key="service_name"
                    variant="primary"
                    class="mr-1 mb-1"
                    style="color: white !important;"
                  >
                    {{ service_name }}
                  </b-badge>
                </template>
                <span v-else-if="service_data.name_of_service">
                  {{ service_data.name_of_service }}
                </span>
                <span v-else>
                  -
                </span>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </b-modal>
  </b-card-code>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  BBadge, BPagination, BFormSelect, BDropdown, BDropdownItem, BCol, BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from 'axios'

export default {
  components: {
    BCardCode,
    VueGoodTable,
    BBadge,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCol,
    BRow,
  },
  data() {
    return {
      pageLength: 25,
      selectedData: {},
      liftingMachineServices: [],
      columns: [
        {
          label: 'Megnevezés',
          field: 'name',
        },
        {
          label: 'Gyártmány',
          field: 'brand',
        },
        {
          label: 'Típus',
          field: 'type',
        },
        {
          label: 'Rendszám',
          field: 'registration_number',
        },
        {
          label: 'Forgalomba helyezés ideje',
          field: 'entry_into_service',
        },
        {
          label: 'Gyártási év',
          field: 'year_of_manufacture',
        },
        {
          label: 'Műszaki vizsga',
          field: 'technical_validity',
        },
        {
          label: 'Gyártási szám',
          field: 'manufacturing_number',
        },
        {
          label: 'Aktuális üzemóra',
          field: 'current_hours',
        },
        {
          label: 'Következő szervíz',
          field: 'service',
        },
        {
          label: 'Műveletek',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  computed: {
    direction() {
      return !!store.state.appConfig.isRTL
    },
  },
  mounted() {
    this.loadLiftingMachineList()
  },
  methods: {
    parseInterval(value) {
      const parsed = parseInt(value, 10)
      return Number.isNaN(parsed) ? 0 : parsed
    },
    detectIntervalUnit(value) {
      if (typeof value === 'string') {
        const lower = value.toLowerCase()
        if (lower.includes('óra')) {
          return 'óra'
        }
      }

      return 'óra'
    },
    deleteThisLiftingMachine(id) {
      axios({
        method: 'delete',
        url: `lifting-machine/delete/${id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeres törlés!',
            text: 'Az emelő gép törölve lett.',
            variant: 'success',
          },
        })
        this.loadLiftingMachineList()
      })
    },
    loadLiftingMachineList() {
      axios({
        method: 'get',
        url: 'lifting-machine/list',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        this.rows = response.data
      })
    },
    getNextServiceTarget(machine) {
      if (!machine) {
        return 0
      }

      const lastService = machine.last_service || null
      const baseValue = lastService && !Number.isNaN(parseInt(lastService.hours_at_the_time_of_service, 10))
        ? parseInt(lastService.hours_at_the_time_of_service, 10)
        : 0
      const intervalSource = lastService && lastService.service_interval ? lastService.service_interval : machine.service_interval
      const interval = this.parseInterval(intervalSource)

      if (interval <= 0) {
        return 0
      }

      if (baseValue > 0) {
        return baseValue + interval
      }

      const current = this.getCurrentUsage(machine)
      if (current !== null) {
        return current + interval
      }

      return interval
    },
    getServiceUnit(machine) {
      const possibleValues = [
        machine ? machine.service_interval : null,
        machine && machine.last_service ? machine.last_service.service_interval : null,
      ]

      const detected = possibleValues
        .filter(value => typeof value === 'string')
        .map(value => value.toLowerCase())
        .find(lower => lower.includes('óra'))

      if (detected) {
        return detected.includes('óra') ? 'óra' : 'óra'
      }

      return 'óra'
    },
    getCurrentUsage(machine) {
      if (!machine) {
        return null
      }

      const candidateKeys = ['current_hours', 'hours', 'operating_hours']

      const foundKey = candidateKeys.find(key => Object.prototype.hasOwnProperty.call(machine, key)
        && !Number.isNaN(parseInt(machine[key], 10)))

      if (foundKey) {
        return parseInt(machine[foundKey], 10)
      }

      return null
    },
    getNextServiceText(machine) {
      const nextTarget = this.getNextServiceTarget(machine)
      if (!nextTarget || nextTarget <= 0) {
        return 'Nincs adat'
      }

      return `${nextTarget} ${this.getServiceUnit(machine)}`
    },
    getNextServiceVariant(machine) {
      if (!machine) {
        return 'primary'
      }

      const current = this.getCurrentUsage(machine)
      if (current === null) {
        return 'primary'
      }

      const parsedService = parseInt(machine.service, 10)
      if (!Number.isNaN(parsedService)) {
        return current < parsedService ? 'success' : 'danger'
      }

      const nextTarget = this.getNextServiceTarget(machine)
      if (!nextTarget || nextTarget <= 0) {
        return 'primary'
      }

      return current < nextTarget ? 'success' : 'danger'
    },
    formatNextService(machine) {
      if (!machine) {
        return 'Nincs adat'
      }

      const raw = machine.service
      if (raw !== undefined && raw !== null) {
        const normalized = `${raw}`.trim()
        if (normalized !== '') {
          const lower = normalized.toLowerCase()
          if (lower.includes('óra')) {
            return normalized
          }

          return `${normalized} ${this.getServiceUnit(machine)}`
        }
      }

      return this.getNextServiceText(machine)
    },
    formatCurrentHours(machine) {
      const current = this.getCurrentUsage(machine)
      if (current === null) {
        return 'Nincs adat'
      }

      return `${current} ${this.getServiceUnit(machine)}`
    },
    formatServiceHistoryNextDue(service) {
      if (!service) {
        return '-'
      }

      const base = parseInt(service.hours_at_the_time_of_service, 10)
      const interval = this.parseInterval(service.service_interval)

      if (Number.isNaN(base) || interval <= 0) {
        return '-'
      }

      return `${base + interval} ${this.detectIntervalUnit(service.service_interval)}`
    },
    getLiftingMachineDetails(id) {
      axios({
        method: 'get',
        url: `lifting-machine/${id}/service/list`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        this.liftingMachineServices = response.data
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
